export class ElasticSearchRequest {
  query: string;
  maxResults: number;
  includeUrl: boolean;
}